import React from "react";
import MuiBox from "@mui/material/Box";
import renderText from "../../../renderText";

function rawChildren(children: any[] = []): string {
    return children.map((child) => {
        if (child?.type === "text") return child.content;
        if (child?.children?.length) return rawChildren(child.children);
        return "";
    }).join("");
}

const SvgMui = ({ html, node, context, children, ...props }: any) => {
    const content =
        html ??
        props.__html ??
        rawChildren(node?.children || []);

    delete props.__html;

    return (
        <MuiBox
            component={'svg'}
            {...props}
            dangerouslySetInnerHTML={{ __html: renderText(`${content}`, context) }}
        />
    );
};


const SvgSrc = ({ src, ...props }: any) => {
    return (
        <MuiBox
            component={'img'}
            src={src}
            {...props}
        />
    );
};

export const Svg = ({ src, children, ...props }: any) => {

    if(!src){
        return <SvgMui {...props} />
    }

    return (
        <SvgSrc src={src} {...props} />
    );
}

export default Svg;
